import {Component, Input, OnInit} from '@angular/core';
import {OrderItemService} from "~/app/core/common/services/order-item.service";
import {OrderItemInsert} from "~/app/core/common/models/orderItemInsert";
import {OrderItemArray} from "~/app/core/common/models/orderItemArray";
import {DialogHelperComponent} from "~/app/shared/helpers/dialog-helper";


@Component({
    selector: 'app-order-upload',
    templateUrl: './order-upload.component.html',
    styleUrls: ['./order-upload.component.scss']
})
export class OrderUploadComponent implements OnInit {
    test: any;

    @Input() itemInsert: OrderItemInsert;
    orderItem: OrderItemArray = new OrderItemArray();
    fileContent: string | ArrayBuffer | null;

    fileName: string = '';
    items: string = '';
    invalidArr: any;

    constructor(private  _orderItemService: OrderItemService, public dialogHelper: DialogHelperComponent) {

    }

    ngOnInit() {
    }


    onFileSelected(event) {
        const file: File = event.target.files[0];

        if (file && file.type === 'text/plain') {
            this.fileName = file.name;
            console.log('file type', file.type);
            let fileReader: FileReader = new FileReader();
            let self = this;
            fileReader.onloadend = async function (x) {
                self.fileContent = fileReader.result; // TODO uncomment this

                if (typeof self.fileContent === "string") {
                    var itemsArr = self.fileContent.split('\n');
                }
                self.itemInsert.orderItems = [];
                itemsArr.forEach(item => {
                    let orderItem = new OrderItemArray();
                    var arr = item.split(',');
                    if (arr[0] != null && arr[0] != undefined) {
                        orderItem.itemNo = arr[0];
                    } else {
                        orderItem.itemNo = '';
                    }

                    if (arr[1] != null && arr[1] != undefined) {
                        orderItem.quantity = +arr[1];
                    } else {
                        orderItem.quantity = 0;
                    }
                    self.itemInsert.orderItems.push(orderItem);

                });

                let tet = await self._orderItemService.uploadOrder(self.itemInsert).then(response => {
                    self.test = response;
                });
                self.invalidArr = self.test.body.invalidIds;
            }

            fileReader.readAsText(file);
            if (typeof this.fileContent === "string") {
                var itemsArr = this.fileContent.split('\n');
            }
        } else {
            console.error('Please upload .txt files only');
            this.dialogHelper.showOkErrorDialog('Error', 'Please upload .txt files only!').then();
        }
    }

}
